"use client";
import { ReactNode } from "react";
import { Loader } from "@/components/ui";
import { getlogoutLoading } from "@/lib/features/profile/profileSlice";
import { useAppSelector, useAppDispatch } from "@/lib/hooks";
import { APIProvider } from "@vis.gl/react-google-maps";

type GoogleMapsProviderProps = {
  children: ReactNode;
};

const API_KEY =
  process.env.NEXT_PUBLIC_PLACE_API_KEY ||
  process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ||
  "";
const MapsProvider = ({ children }: GoogleMapsProviderProps) => {
  const logoutLoading = useAppSelector(getlogoutLoading);
  const dispatch = useAppDispatch();

  return (
    <>
      {logoutLoading && <Loader show={logoutLoading} />}
      <APIProvider apiKey={API_KEY} libraries={["marker", "places"]}>{children}</APIProvider>
    </>
  );
};

export default MapsProvider;
